import {
  FetchBaseQueryError,
  createApi,
  fetchBaseQuery,
} from '@reduxjs/toolkit/query/react';
import { ProductInformationResponse } from 'services/api/responses/responseTypes';

const productInformationApi = createApi({
  reducerPath: 'productInformationApi',
  baseQuery: fetchBaseQuery(),
  endpoints: (builder) => ({
    getProductsInformation: builder.query<
      ProductInformationResponse[],
      string[]
    >({
      queryFn: async (
        baseProductInfo,
        _queryApi,
        _extraOptions,
        fetchWithBQ
      ) => {
        const jsonPromises = baseProductInfo.map((url) => fetchWithBQ(url));

        try {
          const productsInfo = (await Promise.all(jsonPromises)).map(
            (response) => response.data
          );
          return {
            data: productsInfo as ProductInformationResponse[],
          };
        } catch (error) {
          return { error: error as FetchBaseQueryError };
        }
      },
    }),
  }),
});

export default productInformationApi;
